;
define("stock_status_view.tpl", function(){});

